<template>
    <div class="main-categories">
        <div class="main-categories__inner">
            <h1 class="main-categories__heading heading">каталог</h1>
            <div class="main-categories__wrapper">
                <div
                    @click="toCatalog" 
                    class="main-categories__item-all">
                    <p class="main-categories__name main-categories__name_all">Все букеты</p>
                </div>

                <div 
                    v-for="category in CATEGORIES"
                    :key="category.id"
                    :class="{hide: category.name == 'Сопутствующие товары'}"
                    @click="redirectToCatalog(category.name)" 
                    class="main-categories__item">
                    <img
                        v-if="category.backgroundUrl && !isMob" 
                        class="main-categories__img" :src="'https://lenbuket.ru:8443/' + category.backgroundUrl">

                    <img
                        v-if="category.backgroundUrlMob && isMob" 
                        class="main-categories__img" :src="'https://lenbuket.ru:8443/' + category.backgroundUrlMob">

                    <p class="main-categories__name">{{category.name}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    data(){
        return{
            isMob: false
        }
    },
    computed: {
        ...mapGetters([
            'CATEGORIES'
        ])
    },
    methods: {
        ...mapActions([
            'GET_CATEGORIES',
            'SELECT_CATEGORY',
            'GET_PRODUCTS',
            'RESET_PAGE_NUMBER',
            'RESET_SEARCH_VALUE',
            'GET_CATEGORY_VALUE'
        ]),
        toCatalog(){
            this.SELECT_CATEGORY('Все цветы');
            this.RESET_PAGE_NUMBER();
            this.RESET_SEARCH_VALUE();
            this.GET_PRODUCTS();
            this.$router.push('/catalog')
        },
        redirectToCatalog(category){
            this.GET_CATEGORY_VALUE('')
            this.SELECT_CATEGORY(category);
            this.RESET_PAGE_NUMBER();
            this.RESET_SEARCH_VALUE();
            this.GET_PRODUCTS();
            this.$router.push('/catalog')
        }
    },
    mounted() {
        this.GET_CATEGORIES()
        if (window.innerWidth <= 600) {
            this.isMob = true
        }
    },
}
</script>

<style scoped>
    .main-categories__heading{
        margin-bottom: 30px;
    }
    .main-categories__wrapper{
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 20px;
    }
    .main-categories__item-all{
        grid-column: span 2;
        background-color: #D0D0D0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-radius: 20px 70px 70px 20px;
        cursor: pointer;
        transition: all linear .2s;
        min-height: 185px;
    }
    .main-categories__item-all:hover{
        transform: scale(.95);
    }
    .main-categories__item{
        position: relative;
        min-height: 185px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-radius: 20px;
        background: #ECDED3 url(../images/category-wide.png) no-repeat;
        background-size: cover;
        grid-column: span 2;
        padding-right: 25px;
        cursor: pointer;
        transition: all linear .2s;
        overflow: hidden;
    }
    .main-categories__item:hover{
        transform: scale(.95);
        opacity: .7;
    }
    .main-categories__name{
        position: relative;
        width: 100%;
        text-align: end;
        font-size: 22px;
        color: #3A3841;
        font-family: 'Romul';
        z-index: 10;
    }
    .main-categories__name_all{
        text-align: center;
    }
    .main-categories__item:nth-child(5n){
        grid-column: span 1;
        background: #ECDED3 url(../images/category.png) no-repeat;
        background-size: cover;
        padding-right: 15px;
    }
    .main-categories__item:nth-child(5n) + .main-categories__item{
        grid-column: span 1;
        background: #ECDED3 url(../images/category.png) no-repeat;
        background-size: cover;
        padding-right: 15px;
    }
    .hide{
        display: none;
    }
    .main-categories__img{
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
    @media (max-width: 992px) {
        .main-categories__wrapper{
            grid-template-columns: repeat(4, 1fr);
        }
    }
    @media (max-width: 600px){  
        .main-categories__heading{
            margin-bottom: 25px;
        }
        .main-categories__wrapper{
            /* grid-template-columns: repeat(2, 1fr); */
            grid-template-columns: 1fr 1fr;
            gap: 20px 15px;
        }
        .main-categories__item-all{
            min-height: none;
            grid-column: span 1;
            border-radius: 20px 40px 40px 20px;
        }
        .main-categories__item{
            min-height: none;
            grid-column: span 1;
            padding-right: 15px;
            aspect-ratio: 1/1;
        }
        .main-categories__img{
            object-fit: cover;
            aspect-ratio: 1/1;            
        }
        /* .main-categories__item:nth-child(5n){
            grid-column: span 1;
            background: #ECDED3 url(../images/category.png) no-repeat;
            background-size: cover;
            padding-right: 15px;
        }
        .main-categories__item:nth-child(5n) + .main-categories__item{
            grid-column: span 1;
            padding-right: 15px;
        } */
        /* .main-categories__item:nth-last-child(3){
            grid-column: span 2;
        }
        .main-categories__item:nth-last-child(2){
            grid-column: span 2;
        }
        .main-categories__item:nth-last-child(2) + .main-categories__item{
            grid-column: span 2;
        } */
        .main-categories__name{
            font-size: 16px;
        }
    }
</style>